import TeamPage from "./team.page"
export default TeamPage;
